import { SharedModule } from './../shared/shared.module';
import { PipesModule } from '@app/pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CheckoutComponent } from './checkout.component';
import { NgModule } from '@angular/core';
import { routing } from '@app/modules/checkout/checkout.routing';
import { SummaryComponent } from '@app/components/summary/summary.component';
import { ConfirmationComponent } from '@app/components/confirmation/confirmation.component';
import { CheckoutAuthentificationComponent } from '@app/components/checkout-authentification/checkout-authentification.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        routing,
        PipesModule,
        SharedModule
    ],
    declarations: [
        CheckoutComponent,
        SummaryComponent,
        ConfirmationComponent,
        CheckoutAuthentificationComponent
    ],
    exports: [
        CheckoutComponent,
        SummaryComponent,
        ConfirmationComponent,
        CheckoutAuthentificationComponent,
    ]
})

export class CheckoutModule {

}
